import { icons } from '@lifebit-ai/lds'
import React from 'react'

import { getFormTypeLabel } from 'modules/resultsV2/utils'
import type { ResultFormSubmission } from 'services/results/types'

import * as styles from './FormSubmissionPreview.styles'

interface FormSubmissionPreviewProps {
  formSubmission: ResultFormSubmission
  onViewForm: () => void
  hasBorder?: boolean
  title?: string
  formTypeLabel?: string
  viewActionTestId?: string
}

const FormSubmissionPreview = ({
  formSubmission,
  onViewForm,
  hasBorder = true,
  title,
  formTypeLabel,
  viewActionTestId = 'custom-form-view-action'
}: FormSubmissionPreviewProps): JSX.Element => {
  const displayTitle = title ?? formSubmission.formName
  const displaySubtitle =
    title !== undefined ? formSubmission.formName : formTypeLabel ?? getFormTypeLabel(formSubmission.type)
  const FormIcon = title !== undefined ? icons.DocsSmall : icons.File

  return (
    <styles.ItemRow $hasBorder={hasBorder}>
      <styles.ItemIcon>
        <FormIcon />
      </styles.ItemIcon>
      <styles.ItemInfo>
        <styles.ItemTitle>{displayTitle}</styles.ItemTitle>
        <styles.ItemSubtitle>{displaySubtitle}</styles.ItemSubtitle>
      </styles.ItemInfo>
      <styles.RowActionButton type="tertiary" data-testid={viewActionTestId} onClick={onViewForm}>
        <icons.EyeSmall />
        <span>View</span>
      </styles.RowActionButton>
    </styles.ItemRow>
  )
}

export default FormSubmissionPreview
